import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CreateMyMenuService {
  private apiUrlfood = 'http://localhost:3000/Sp_Menu';  // Mock API URL

  constructor(private http: HttpClient) { }

  getFoods(): Observable<{ event:string, type: string, text: string, image: string, priceperplate: string , typedesc: string}[]> {
    
    return this.http.get<{ event:string, type: string, text: string, image: string, priceperplate: string,typedesc: string }[]>(this.apiUrlfood)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('An error occurred:', error);
    return throwError('Something went wrong; please try again later.');
  }
}